import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

// 🔥 Use API base from .env
const API_BASE = process.env.REACT_APP_API_BASE;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ===============================
     CHECK SESSION ON APP LOAD
  =============================== */
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await fetch(`${API_BASE}/auth/check-auth.php`, {
          method: "GET",
          credentials: "include", // 🔥 REQUIRED FOR PHP SESSION
        });

        const data = await res.json();

        if (res.ok && data.status) {
          setUser(data.user);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  /* ===============================
     LOGIN
  =============================== */
  const login = (userData) => {
    setUser(userData);
  };

  /* ===============================
     LOGOUT
  =============================== */
  const logout = async () => {
    try {
      await fetch(`${API_BASE}/auth/logout.php`, {
        method: "POST",
        credentials: "include",
      });
    } catch (err) {
      console.error("Logout error:", err);
    } finally {
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        login,
        logout,
        loading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}